import './style/index.js';

import _Upload from './upload';

export * from './type';

export const Upload = _Upload;
export default Upload;
